import { Button, Paper, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LockIcon from '@mui/icons-material/Lock';
import styles from './index.module.css';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../util';

export default function AccountConfirmed(): JSX.Element {
  const navigate = useNavigate();

  return (
    <section className={styles.main}>
      <Paper className={styles.wrapper} elevation={3}>
        <LockIcon color="disabled" className={styles.icon} />
        <Typography>Password reset.</Typography>
        <Typography>
          You are now able to log in with your new password.
        </Typography>
        <Button
          className={styles.button}
          fullWidth
          startIcon={<NavigateNextIcon />}
          variant="contained"
          onClick={() => {
            navigate(Routes.LOGIN);
          }}
        >
          Log In
        </Button>
      </Paper>
    </section>
  );
}
